import { Observable } from "rxjs";
import { falUserModel, serviceUsageModel } from "./falUserDefinitions";
import { ExternalDataSource, NtCompany } from './nt-company';

export interface basicAuthenticationModel {
  username: string;
  password: string;
}

export interface serviceAuthenticationModel extends basicAuthenticationModel {
  serviceDescriptor: string ;
}

export interface serviceRefreshAuthenticationModel {
  authToken: string;
  refreshToken: string;
  serviceDescriptor: string ;
}

export interface userPasswordUpdateModel {
  userId: string;
  currentPassword: string;
  proposedPassword: string;
  serviceDescriptor: string;
}

export interface serviceAuthenticationResult {
  token;
  refreshToken: string;
  user: falUserModel;
  result: string;
}

export interface uiAuthResult {
  ok: boolean;
  error?: string;
  requireVerification: boolean;
}

export interface AuthenticationStatusDetail {
  isAuthenticated: boolean;
  reason: AuthenticationStatusPurpose;
}

export enum AuthenticationStatusPurpose {
  Initialisation,
  Login,
  Logout,
  Refresh,
  RefreshFail,
  PasswordChange
}

export enum ValidateAuthResult {
  Pending,
  Failed,
  Success,
  RefreshFailed
}

export class uiValidateAuthResult {
    constructor(public nextPromise: Observable<uiAuthResult>,
        public result: ValidateAuthResult) {
    
      }
}

export interface ntAuthResult{
  result: string;
  companies: NtCompany[];
  serviceUsage: serviceUsageModel[];
}

export interface CreateNtCompanyResult {
  company: NtCompany;
  service: serviceUsageModel
}

export interface SsoIdentity {
  uuid: string;
  email: string;
  givenName: string;
  familyName: string;
  phone: string;
  address?: string;
  provider: string;
  verified: boolean;
}

export interface SsoResult {
    dataSource: ExternalDataSource;
    identity: SsoIdentity;
    company: NtCompany;
    companyStatus: NewCompanyStatus;
    user: falUserModel;
}

export enum NewCompanyStatus {
    New = "New",
    ExistingNonCritical = "ExistingNonCritical",
    ExistingCriticalIgnored = "ExistingCriticalIgnored",
    ExistingCritical = "ExistingCritical",
    ExistingPendingDeletion = "ExistingPendingDeletion",
    NotFoundSso = "NotFoundSso",
    ExistingSso = "ExistingSso",
    ExistingSsoUserActive = "ExistingSsoUserActive",
    NoCompanySpecified = "NoCompanySpecified",
}

export interface SsoProvider {
  provider: string;
  url: string;
}


export interface SsoRequestResult {
  state: string;
  providers: SsoProvider[];
}

export interface ServiceSsoAuthModel {
  provider: string;
  uuid: string;
  email: string;
  serviceDescription;
}

export interface ExternalDataResultSsoRequest {
  data: SsoRequestResult;
  result: string;
  meta: string;
}

export interface ExternalDataResultSsoIdentity {
  data: SsoResult;
  result: string;
  meta: string;
}
